import _typeof from "@babel/runtime/helpers/esm/typeof";
// Is a given variable an object?
export default function isObject(obj) {
  var type = _typeof(obj);

  return type === 'function' || type === 'object' && !!obj;
}